// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3GSuL","col":"Table_col__1MGWH","fulfillmentStatus":"Table_fulfillmentStatus__u551x","emailCol":"Table_emailCol__27w3a"};